export interface BinaryFilters {
  myVotes: boolean
  awaitingResults: boolean
}

export const getInitialBinaryFilters = (): BinaryFilters => ({
  myVotes: false,
  awaitingResults: false,
})
